<template>
  <div :class="org">
    <div class="site-header row">
      <Logo v-if="scholarship" :logo_url="scholarship.organization.logo_url" :link_url="path" />
      <div class="col-4">
        <img src="../assets/tassyl9-grey.png" class="top-logo mt-4">
        <div class="tagline text-center">
          <p>Connecting you to your future.</p>
        </div>
      </div>
      <LoginStatus/>
    </div>
    <ScholarshipHeader
      v-if="scholarship"
      :organization_name="scholarship.organization.organization_name"
      :scholarship_name="scholarship.name"
      :enrollment_period="enrollment_period">
    </ScholarshipHeader>
    <div v-if="scholarship">
      <NavArrows :active="scholarship.active"/>
    </div>
    <div v-else>
      <NavArrows :active="{false: false}"/>
    </div>
    <router-view class="pt-4 pb-4"></router-view>
  </div>
</template>

<script>
import Logo from './organizations/Logo'
import LoginStatus from './LoginStatus'
import ScholarshipHeader from './ScholarshipHeader'
import axios from '../auth'
import NavArrows from './NavArrows'

export default {
  components:{
    Logo,
    LoginStatus,
    ScholarshipHeader,
    NavArrows
  },
  data(){
    return {
      scholarship: null,
      enrollment_period: {},
      path: `/${this.$route.params.organization_name}/${this.$route.params.scholarship_name}`,
      org: this.$route.params.organization_name
    }
  },
  mounted(){
    this.getScholarship()
  },
  methods:{
    getScholarship: function() {
      axios.get(`${process.env.VUE_APP_ENDPOINT}/api/${this.$route.params.organization_name}/${this.$route.params.scholarship_name}/`)
        .then(res => {
          this.scholarship = res.data
          this.setEnrollmentPeriodString()
        })
      .catch(err=>{
          this.msg = err
          if( err.response && err.response.status === 404 ){
          this.$router.push({name: 'notFound'})
          }
         if( err.response && err.response.status === 500 ){
          this.$router.push({name: 'notFound'})
          }
        })
    },
    setEnrollmentPeriodString() {
      if (this.scholarship.active) {
        this.enrollment_period.title = "SUBMISSION DEADLINE: "
        this.enrollment_period.date = this.scholarship.active.close
      }
      else if (this.scholarship.upcomming) {
        this.enrollment_period.title = "Next enrollment period begins on "
        this.enrollment_period.date = this.scholarship.upcomming.open
        this.scholarship.active = {false: false}
      }
      else if (this.scholarship.closed){
        this.enrollment_period.title = "Enrollment period ended on "
        this.enrollment_period.date = this.scholarship.closed.close
        this.scholarship.active = {false: false}
      }
      else{
        this.enrollment_period.title = ""
        this.enrollment_period.date = ""
      }
    }
  }
}
</script>

<style lang="scss" scoped>

#deadline {
  background-color: #1B86B5;
  color: white;
  font-size: 2em;
}

</style>
